import type { RegistryEntry } from '../types';
import { clampTo } from '../../tools';

export const ideogramConfigs: Record<string, RegistryEntry> = {
  'ideogram-v4': {
    options: [
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [
          { label: 'JPEG', value: 'jpeg' },
          { label: 'PNG', value: 'png' },
        ],
        default: 'jpeg',
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => ({
      output_format: clampTo(
        ui.output_format || 'jpeg',
        ['jpeg', 'png'] as const,
        'jpeg',
      ),
    } as unknown as Record<string, Record<string, any>>),
  },
};